/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TariffaMensaCondizioneForm } from './tariffa-mensa-condizione-form';


export interface TariffaMensaRegolaForm { 
    ordine: number;
    contributo: number;
    contributo_multifiglio?: number;
    condizioni?: Array<TariffaMensaCondizioneForm>;
}

